import * as Game from '../../../models/game';
import {
  STAT_TYPE_FOUR_FACTORS,
  STAT_TYPE_SCORING,
  STAT_TYPE_PROFILE,
} from '../../../shared/constants';

export const chartTypes = [
  { name: 'Scoring', value: STAT_TYPE_SCORING },
  { name: 'Four Factors', value: STAT_TYPE_FOUR_FACTORS },
  { name: 'Shooting Profile', value: STAT_TYPE_PROFILE },
];

export const chartsByType = {
  [STAT_TYPE_SCORING]: [
    {
      name: 'Total Points',
      getValue: Game.getTotalPoints,
      isPercent: false,
    },
    {
      name: 'Total Points Allowed',
      getValue: Game.getTotalPointsAllowed,
      isPercent: false,
    },
    {
      name: 'Total Plus-Minus Points',
      getValue: Game.getTotalPlusMinusPoints,
      isPercent: false,
    },
    {
      name: 'Total Possessions',
      getValue: Game.getTotalPossessions,
      isPercent: false,
    },
    {
      name: 'Points per Possessions',
      getValue: Game.getPointsPerPossessions,
      isPercent: false,
    },
    {
      name: 'Plus-Minus Points per Possessions',
      getValue: Game.getPlusMinusPointsPerPossessions,
      isPercent: false,
    },
    {
      name: 'Total Time Played',
      getValue: Game.getTotalTimePlayed,
      isPercent: false,
    },
    {
      name: 'Points per Minute',
      getValue: Game.getPointsPerMinute,
      isPercent: false,
    },
    {
      name: 'Plus-Minus Points per Minute',
      getValue: Game.getPlusMinusPointsPerMinute,
      isPercent: false,
    },
  ],
  [STAT_TYPE_FOUR_FACTORS]: [
    {
      name: 'EFG',
      getValue: Game.getEfg,
      isPercent: true,
    },
    {
      name: 'Opp EFG',
      getValue: Game.getOpponentEfg,
      isPercent: true,
    },
    {
      name: 'Net EFG',
      getValue: Game.getNetEfg,
      isPercent: true,
    },
    {
      name: 'ORR',
      getValue: Game.getOrr,
      isPercent: true,
    },
    {
      name: 'Opp ORR',
      getValue: Game.getOpponentOrr,
      isPercent: true,
    },
    {
      name: 'Net ORR',
      getValue: Game.getNetOrr,
      isPercent: true,
    },
    {
      name: 'FTR',
      getValue: Game.getFtr,
      isPercent: true,
    },
    {
      name: 'Opp FTR',
      getValue: Game.getOpponentFtr,
      isPercent: true,
    },
    {
      name: 'Net FTR',
      getValue: Game.getNetFtr,
      isPercent: true,
    },
    {
      name: 'TOV',
      getValue: Game.getTov,
      isPercent: true,
    },
    {
      name: 'Opp TOV',
      getValue: Game.getOpponentTov,
      isPercent: true,
    },
    {
      name: 'Net TOV',
      getValue: Game.getNetTov,
      isPercent: true,
    },
  ],
  [STAT_TYPE_PROFILE]: [
    {
      name: 'At the Rim FG%',
      getValue: Game.getAtr,
      isPercent: true,
    },
    {
      name: 'Opp At the Rim FG%',
      getValue: Game.getOpponentAtr,
      isPercent: true,
    },
    {
      name: 'Net At the Rim FG%',
      getValue: Game.getNetAtr,
      isPercent: true,
    },
    {
      name: 'At the Rim Rate%',
      getValue: Game.getAtrRate,
      isPercent: true,
    },
    {
      name: 'Opp At the Rim Rate%',
      getValue: Game.getOpponentAtrRate,
      isPercent: true,
    },
    {
      name: 'Net At the Rim Rate%',
      getValue: Game.getNetAtrRate,
      isPercent: true,
    },
  ],
};
